import { createApp } from 'vue'
import store from './store'
import App from './App.vue'
import { router } from './router'
import VueLazyload from 'vue-lazyload'
import { setupCalendar, DatePicker } from 'v-calendar';
import 'v-calendar/style.css';



const app = createApp(App)
app.use(VueLazyload)
app.use(store)
app.use(router)

app.use(setupCalendar, {})
app.component('VDatePicker', DatePicker)

app.mount('#app')

